// extracted by mini-css-extract-plugin
export default {"input":"label-with-inputs_input__r93dl","placeHolderShimmer":"label-with-inputs_placeHolderShimmer__C879l"};